import { useAxiosPrivate } from "./axios";

const LIST_QUERY = "/scheduledjob/list";
const START_QUERY = "/scheduledjob/start";
const STOP_QUERY = "/scheduledjob/stop";
const RUN_QUERY = "/scheduledjob/run";
const LIST_LOGS = "/scheduledjob/logs";

export const useLoadJobs = () => {
  const loadJobs = async (callback) => {
    try {
      const controller = new AbortController();
      const response = await axiosPrivate.get(LIST_QUERY, {
        signal: controller.signal,
      });
      callback(response.data);
    } catch (err) {
      callback(err);
    }
  };

  const axiosPrivate = useAxiosPrivate();
  return loadJobs;
};

export const useRunJob = () => {
  const runJob = async (jobId, callback) => {
    try {
      const controller = new AbortController();
      const response = await axiosPrivate.patch(`${RUN_QUERY}?id=${jobId}`, {
        signal: controller.signal,
      });
      callback(response.data);
    } catch (err) {
      callback(err);
    }
  };

  const axiosPrivate = useAxiosPrivate();
  return runJob;
};

export const useStopStartJob = () => {
  const disableJob = async (jobId, disabled, callback) => {
    const query = disabled ? STOP_QUERY : START_QUERY;
    try {
      const controller = new AbortController();
      const response = await axiosPrivate.patch(`${query}?id=${jobId}`, {
        signal: controller.signal,
      });
      callback(response.data);
    } catch (err) {
      callback(err);
    }
  };

  const axiosPrivate = useAxiosPrivate();
  return disableJob;
};

export const useListJobLogs = () => {
  const listJobLogs = async (jobId, page, limit, callback) => {
    try {
      const controller = new AbortController();
      const offset = page * limit;
      const response = await axiosPrivate.get(LIST_LOGS, {
        params: {
          id: jobId,
          limit: limit,
          offset: offset,
        },
        signal: controller.signal,
      });
      callback(response.data);
    } catch (err) {
      callback(err);
    }
  };

  const axiosPrivate = useAxiosPrivate();
  return listJobLogs;
};
